"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkNFQD3NML_js = require('./chunk-NFQD3NML.js');
var p = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var p__default = /*#__PURE__*/_interopDefaultLegacy(p);

var F=p__default["default"].form`
  display: flex;
  flex-direction: column;
`,o={Form:F};var e=({children:m,size:l="regular",...i})=>jsxRuntime.jsx(chunkNFQD3NML_js.a,{value:{size:l},children:jsxRuntime.jsx(o.Form,{...i,children:m})});e.displayName="Form";var d=e;

exports.a = d;
